import { zhCN } from '@mui/x-date-pickers/locales';
import { getLanguageConfig, LANGUAGES } from '../constants/appConstants';

const ZH_PICKER_LOCALE_TEXT = zhCN.components.MuiLocalizationProvider.defaultProps.localeText;

export const getDatePickerProviderProps = (language) => {
  const { dayjs: adapterLocale } = getLanguageConfig(language);

  if (language === LANGUAGES.ZH) {
    return { adapterLocale, localeText: ZH_PICKER_LOCALE_TEXT };
  }

  return { adapterLocale };
};
